import axiosInstance from './axios';

export const clientService = {
  getClients: async (params = {}) => {
    const response = await axiosInstance.get('/clients', { params });
    return response.data;
  },

  getClient: async (id) => {
    const response = await axiosInstance.get(`/clients/${id}`);
    return response.data;
  },

  createClient: async (clientData) => {
    const response = await axiosInstance.post('/clients', clientData);
    return response.data;
  },

  updateClient: async (id, clientData) => {
    const response = await axiosInstance.put(`/clients/${id}`, clientData);
    return response.data;
  },

  deleteClient: async (id) => {
    const response = await axiosInstance.delete(`/clients/${id}`);
    return response.data;
  },

  getClientStatistics: async (id) => {
    const response = await axiosInstance.get(`/clients/${id}/statistics`);
    return response.data;
  },

  getAllStatistics: async () => {
    const response = await axiosInstance.get('/clients/all-statistics');
    return response.data;
  },

  blockClient: async (id, reason) => {
    const response = await axiosInstance.post(`/clients/${id}/block`, { reason });
    return response.data;
  },

  unblockClient: async (id) => {
    const response = await axiosInstance.post(`/clients/${id}/unblock`);
    return response.data;
  },

  resetClientPassword: async (id) => {
    const response = await axiosInstance.post(`/clients/${id}/reset-password`);
    return response.data;
  },
};
